import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"
import { Role, authorize } from "helpers/authorize"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [sell, setsell] = useState(false)
  const [buy, setbuy] = useState(false)
  const [settings, setsettings] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var matchingMenuItemAlternative = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      } else if (
        items[i].pathname != "/" &&
        props.location.pathname.includes(items[i].pathname)
      ) {
        matchingMenuItemAlternative = items[i]
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    } else if (matchingMenuItemAlternative) {
      activateParentDropdown(matchingMenuItemAlternative)
    }
  })

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle arrow-none"
                    href="/v1/campaigns"
                  >
                    <i className="bx bx-home-circle me-2"></i>
                    {props.t("Default")}
                  </a>
                </li>
                {authorize([Role.Dev]) ? (
                  <>
                    <li className="nav-item dropdown">
                      <a
                        href="/v1/products"
                        className="nav-link dropdown-togglez arrow-none"
                      >
                        <i className="bx bx-store me-2"></i>
                        {props.t("Products")}
                      </a>
                    </li>

                    <li className="nav-item dropdown">
                      <a
                        href="/v1/companies"
                        className="nav-link dropdown-togglez arrow-none"
                      >
                        <i className="bx bx-customize me-2"></i>
                        {props.t("Companies")}
                      </a>
                    </li>
                  </>
                ) : null}
                {authorize([Role.DevMaster, Role.Dev, Role.Admin]) ? (
                  <>
                    <li className="nav-item dropdown">
                      <a
                        href="/v1/brands"
                        className="nav-link dropdown-togglez arrow-none"
                      >
                        <i className="bx bx-tag me-2"></i>
                        {props.t("Brands")}
                      </a>
                    </li>
                  </>
                ) : null}

                {authorize([Role.DevMaster, Role.Dev, Role.Admin]) ? (
                  <>
                    <li className="nav-item dropdown">
                      <a
                        href="/settings"
                        className="nav-link dropdown-togglez arrow-none"
                      >
                        <i className="bx bx-cog me-2"></i>
                        {props.t("Settings")}
                      </a>
                    </li>
                  </>
                ) : null}
                {/* <li className="nav-item dropdown">
                  <Link
                    to="/v1/kasa/sell" 
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    {props.t("Sell")}
                  </Link> 
                </li> */}
                {/* <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                      setsettings(!settings)
                    }}
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    <i className="bx bx-cog me-2"></i>
                    {props.t("Settings")} <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: settings })}> 
                    <Link to="/settings/banks" className="dropdown-item">
                      {props.t("Banks")}
                    </Link> 
                    <Link to="/settings/persons" className="dropdown-item">
                      {props.t("Persons")}
                    </Link> 
                  </div>
                </li> */}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
